import { type ControlRules } from '@repo/api-gw-sdk';

import { RetentionPopover } from './retentionSelectionPopover';

export function MaximumRetentionEditor({
  rules,
  onChange,
}: {
  rules: ControlRules;
  onChange: (rules: ControlRules) => void;
}) {
  const initialRetentionDays = rules.maximumRetention?.maximumRetention || 30;

  const onUpdate = (value: number) => {
    onChange({
      maximumRetention: {
        enabled: true,
        maximumRetention: value,
      },
    });
  };

  return (
    <>
      <RetentionPopover
        initialRetentionInDays={initialRetentionDays}
        onUpdate={onUpdate}
      />
    </>
  );
}
